// extracted by mini-css-extract-plugin
export default {"notification":"x_o0svK","radios":"zRi8MvC"};